import API from '@/api/Residential'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Residential')
import { i18n } from '@/i18n'
import { path } from 'ramda'
import { ResidentialNumberPatternParser } from '@/utils'

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {
  name: state => {
    if (state.item.displayName) return state.item.displayName
    if (!state.item.number) return
    let number = state.item.number
    let pattern = path(['project', 'metadata', 'residentialNumberPattern'], state.item)

    if (pattern) number = ResidentialNumberPatternParser(pattern, number)

    return `${i18n.tc('unit')} ${number}`
  },
  getDisabledField: state => field => {
    return path(['item', 'metadata', 'disabledFields', field], state)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
